import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  for: "objeto-select",
  class: "form-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label) + ":", 1),
    _createVNode(_component_MultiSelect, {
      modelValue: _ctx.selectedObjeto,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedObjeto) = $event)),
      options: _ctx.objeto,
      mode: "single",
      searchable: true,
      "close-on-select": true,
      valueProp: "valor",
      trackBy: "texto",
      label: "texto",
      placeHolder: "Selecione uma Sala",
      id: "item-select"
    }, null, 8, ["modelValue", "options"])
  ]))
}